import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { Home, Video, Brain, Grid3x3, User } from 'lucide-react';
import { motion } from 'framer-motion';

export const MobileNav = () => {
  const location = useLocation();

  const menuItems = [
    { icon: Home, label: 'Início', path: '/dashboard' },
    { icon: Video, label: 'Vídeos', path: '/videos' },
    { icon: Brain, label: 'Quiz', path: '/quiz' },
    { icon: Grid3x3, label: 'Caça-P', path: '/caca-palavras' },
    { icon: User, label: 'Perfil', path: '/perfil' },
  ];

  const isActive = (path) => location.pathname === path;

  return (
    <motion.div
      initial={{ y: 80 }}
      animate={{ y: 0 }}
      className="md:hidden fixed bottom-0 left-0 right-0 h-16 bg-white/95 backdrop-blur-lg border-t border-border flex justify-around items-center z-50 px-2"
    >
      {menuItems.map((item) => (
        <Link
          key={item.path}
          to={item.path}
          data-testid={`mobile-nav-${item.label.toLowerCase().replace(/\s+/g, '-')}`}
          className={`flex flex-col items-center justify-center gap-1 px-3 py-2 rounded-lg transition-all ${
            isActive(item.path)
              ? 'text-primary'
              : 'text-muted-foreground'
          }`}
        >
          <item.icon className={`h-5 w-5 ${isActive(item.path) ? 'stroke-[2.5]' : ''}`} />
          <span className="text-[10px] font-medium">{item.label}</span>
        </Link>
      ))}
    </motion.div>
  );
};
